import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import NoLoginPage from 'components/layout/NoLogInPage';

import { selectedImagesAtom } from 'components/pages/onboardingNew/newOnboardingAtom'
import { useAtom } from "jotai"
import { BiCheck } from "react-icons/bi";
// import ReactGA from "react-ga4";
import Footer from 'components/pages/homePage/layout/Footer/Footer_Mobile';
import ReactPixel from 'react-facebook-pixel';

const Elem:React.FC<any> = () => {
  const [ selectedImage, setSelectedImage ] = useAtom(selectedImagesAtom);
  const navigate = useNavigate();

  const handleGotoDetail = () => {
    const selectedPhotos = [
      { 'id': selectedImage[0], 'quantity': 1 },
      { 'id': selectedImage[1], 'quantity': 2 },
      { 'id': selectedImage[2], 'quantity': 3 },
      { 'id': selectedImage[3], 'quantity': 4 },
      { 'id': selectedImage[4], 'quantity': 5 },
    ];
      
    const contentIds = selectedPhotos.map(photo => photo.id);
      ReactPixel.fbq('track', 'AddToCart', {
        "content_ids": contentIds,
        "content_name": 'Free Trial Photos',
        "content_type": 'product', 
        "contents": selectedPhotos,
        "currency": 'KRW', 
        "value": 0,
        "country": "KR",
        "gender": "female"
      })

    navigate('/onboarding/2/detail');

    // ReactGA.event({
    //   "category" : "Button",
    //   "action" : "Click",
    //   "label": "go to input detail modal"
    // })
  };

  return (
    <Background>      
      <ModalContainer>
      <NoLoginPage disable={false}>      
        <TestContainer>
        <ContextContainer>
          <TextContainer>
          <SmallText className="first"><span>0/2</span>단계</SmallText>
            {/* <BigText className="Top">구독을 체험할 수 있는</BigText> */}
            <BigText className="Bottom">놓치기 아까운 <br/> 5장 인화 준비가 완료됐어요!</BigText>
            {/* <BigText className="Bottom">5장 인화 준비가 완료됐어요!</BigText> */}
            <SmallText className="small">신청 완료하고 받아보세요.</SmallText>
          </TextContainer>
          <PhotoContainer>
            <DetailPhotoContainer>
              <SmallPhotoWrapper>
                {selectedImage.length > 0 && (
                  <SelectPhotoWrapper src={selectedImage[0]} />
                )}
              </SmallPhotoWrapper>
            <SmallPhotoWrapper>
                {selectedImage.length > 1 && (
                  <SelectPhotoWrapper src={selectedImage[1]} />
                )}
              </SmallPhotoWrapper>
              <SmallPhotoWrapper>
                {selectedImage.length > 2 && (
                  <SelectPhotoWrapper src={selectedImage[2]} />
                )}
              </SmallPhotoWrapper>
              </DetailPhotoContainer>
            <DetailPhotoContainer>
              <SmallPhotoWrapper>
                {selectedImage.length > 3 && (
                  <SelectPhotoWrapper src={selectedImage[3]} />
                )}
              </SmallPhotoWrapper>
            
              
              <SmallPhotoWrapper>
                {selectedImage.length > 4 && (
                  <SelectPhotoWrapper src={selectedImage[4]} />
                )}
              </SmallPhotoWrapper>
              <SmallPhotoWrapper>
                <ContentsContainer>
                  <CheckContainer>
                    <ModifiedChecked />
                  </CheckContainer>
                  <TinyText>전송완료</TinyText>
                </ContentsContainer>
              </SmallPhotoWrapper>
            </DetailPhotoContainer>
          </PhotoContainer>
          <ButtonWrapper>
            <GoToAddressButton
            onClick={handleGotoDetail}
            >배송 정보 입력</GoToAddressButton>
          </ButtonWrapper>         
        </ContextContainer>
        <ModifiedFooter />
        </TestContainer>
        </NoLoginPage>  
      </ModalContainer>
    </Background>
  )
};

export default Elem;

const Background = styled.div`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: white;
  z-index: 0;
`
const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  /* background-color: white; */
  background-color: #F5F3EF;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  z-index: 1;
  
`;

const ContextContainer = styled.div`
  /* max-width: 320px; */
  width: 100%;
  padding: 20px 17px;
  @media (max-width:321px) {
    width: 90%;
  }
  display: flex;
  flex-direction: column;
  margin: 24px auto;
`
const TextContainer = styled.div`
  /* width: 267px; */
  /* height: 87px; */
  display: flex;
  flex-direction: column;
  align-items: baseline;
`;
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 24px;
  line-height: 100%;
  color: #141414;
    @media (max-width:321px) {
    font-size: 20px;
  }

  &.Top {
    font-size: 25px;
    font-weight: 300;
    margin-bottom: 5px;
  }

  &.Bottom {
    font-weight: Bold;
    line-height: 27px;
    letter-spacing: -0.03em;
  }
`;
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 13px;
  line-height: 100%;
  color: #141414;
  margin-bottom: 16px;

  @media (max-width:321px) {
    font-size: 10px;
  }

  span {
    font-weight: 700;
  }

  &.small{
    font-size: 13px;
    font-weight: 300;
    margin-top: 16px;
    margin-bottom: 0;
    line-height: 3%;
    color: rgba(117, 117, 117, 1);
  }
`;
const PhotoContainer = styled.div`
  width: 100%;
  /* min-height: 600px; */
  margin: 37px auto 0;

  @media (max-width: 321px) {
    min-height: 450px;
  }
`;
const DetailPhotoContainer = styled.div`
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const SmallPhotoWrapper = styled.div`
  width: 32%;
  aspect-ratio: 1/1;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  &.button {
    position: absolute;
  }
  @media (max-width: 321px) {
    width: 49% ;
    aspect-ratio: 1/1;
    /* height: 80px; */
  }

  /* border: 0.8px solid #262626; */
  border-radius: 10px;
`
const ButtonWrapper = styled.div`
  /* max-width: 320px; */
  width: 100%;
  @media (max-width:321px) {
    width: 90%;
  }
  height: 52px;
  margin: 80px auto 50px;
`;
const SelectPhotoWrapper = styled.img`
  width: 100%;
  height: 100%;
  object-fit:cover;
  border-radius: 5px;
`;
const ContentsContainer = styled.div`
  width: 70px;
  aspect-ratio: 1/1;
  display: flex;
  flex-direction: column;
`;
const TinyText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 100%;
  text-align: center;
  color: #141414;
  margin-top: 8px;
`
const CheckContainer = styled.div`
  width: 40px;
  height: 40px;
  margin: 0 auto;
`;
const ModifiedChecked = styled(BiCheck)`
  width: 100%;
  height: 100%;
`
const GoToAddressButton = styled.button`
  width: 100%;
  height: 100%;
  background-color: #DBC6A7;
  border-radius: 30px;
  color: white;
`

const TestContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
`

const ModifiedFooter = styled(Footer)`
  background-color: yellow;
`
